var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoCarGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "15px",
    viewBox: "0 0 21 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KPI-dashboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Manage-Ride-Final-Copy-4",
    transform: "translate(-179.000000, -302.000000)",
    fill: "#4CAF50"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/24x24/ico_car",
    transform: "translate(177.955685, 297.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.0001,15 L4.0001,18 L6,18 L6,16 L18,16 L18,18 L20.0001,18 L20.0001,15 L17,15 L17,13 L20.0001,13 L20.0001,12.3263303 L19.5,12 L4.5,12 L4.0001,12.3263303 L4.0001,13 L7,13 L7,15 L4.0001,15 Z M6.2,10 L17.8,10 L16.6489734,7 L7.35122662,7 L6.2,10 Z M8,18 L8,20 L2.0001,20 L2.0001,11.2598697 L4.19815686,9.78482849 L6.12897338,5 L17.8712266,5 L19.8020431,9.78482849 L22.0001,11.2598697 L22.0001,20 L16,20 L16,18 L8,18 Z M9,15 L9,13 L15,13 L15,15 L9,15 Z",
    id: "shape",
    fill: "#34C759"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCarGreen);
export default __webpack_public_path__ + "static/media/ico_car_green.7bb963a4ffdbee61dc6f1fa7dfbafdd6.svg";
export { ForwardRef as ReactComponent };